<template>
  <div class="project-card">
    <div class="card-img-wrapper">
      <img :src="card.src" alt="" />
      <div class="card-img-gradient"></div>
    </div>
    <div class="card-title">{{ card.title }}</div>
    <div class="card-subtitle">{{ card.subtitle }}</div>
    <div class="card-actions">
      <a
        class="card-action-btn"
        v-for="action in card.actions"
        :key="action.title"
        :href="action.link"
        target="_blank"
      >{{ action.title }}</a>
      <div style="flex: 1"></div>
      <button class="card-expand-btn" @click="show = !show">
        <span :class="'mdi ' + (show ? 'mdi-chevron-up' : 'mdi-chevron-down')"></span>
      </button>
    </div>
    <div v-show="show">
      <hr class="card-divider" />
      <div class="card-text">{{ card.details }}</div>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    show: false,
  }),
  props: {
    card: Object
  }
}
</script>

<style scoped>
.project-card {
  background: #c0c0c0;
  border: 2px solid;
  border-color: #ffffff #808080 #808080 #ffffff;
  max-width: 344px;
  margin: 0 auto;
}

.card-img-wrapper {
  position: relative;
  height: 200px;
  overflow: hidden;
}

.card-img-wrapper img {
  width: 100%;
  height: 200px;
  object-fit: cover;
  display: block;
}

.card-img-gradient {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  background: linear-gradient(to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5));
}

.card-title {
  padding: 8px 16px 4px;
  font-weight: bold;
  font-size: 13px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.card-subtitle {
  padding: 0 16px 8px;
  font-size: 11px;
  color: #444;
}

.card-actions {
  display: flex;
  align-items: center;
  padding: 4px 8px;
  gap: 4px;
}

.card-action-btn {
  padding: 2px 8px;
  background: #c0c0c0;
  border: 2px solid;
  border-color: #ffffff #808080 #808080 #ffffff;
  text-decoration: none;
  color: #356859;
  font-size: 11px;
  cursor: default;
}

.card-action-btn:active {
  border-color: #808080 #ffffff #ffffff #808080;
}

.card-expand-btn {
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #c0c0c0;
  border: 2px solid;
  border-color: #ffffff #808080 #808080 #ffffff;
  cursor: pointer;
  font-size: 16px;
  padding: 0;
}

.card-expand-btn:active {
  border-color: #808080 #ffffff #ffffff #808080;
}

.card-divider {
  border: none;
  border-top: 1px solid #808080;
  margin: 0;
}

.card-text {
  padding: 8px 16px;
  font-size: 11px;
}
</style>
